import { Component, Input, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { AuditlogServiceService } from 'src/app/services/um/auditlog-service.service';
import { AuditlogRevisionsComponent } from '../auditlog-revisions/auditlog-revisions.component';
import { SuperadminExportComponent } from '../superadmin-export/superadmin-export.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-category-auditlog',
  templateUrl: './category-auditlog.component.html',
  styleUrls: ['./category-auditlog.component.scss']
})
export class CategoryAuditlogComponent implements OnInit {

  subGetAuditLogDetailsList: SubscriptionLike;
  subGetAuditLogDetailsList1: SubscriptionLike;

  @Input() public Content: any;
  gridApi: GridApi;
  selectedRow: any;
  columnDefs: any;
  rowData: any = [];
  operations;
  public content: any;
  gridBar:boolean=false;
  RevisionNo: any
  ArrayversionId: any = []
  ArrayCatagorytype: string
  RelatedPKID: string
  versionids: any;
  Catagory_type: string;
  log_data: any;
  revisionDetails: RevisionDetails = new RevisionDetails();
  action: Subject<any> = new Subject();
  gridOptions: { pagination: boolean; rowSelection: string; rowHeight: number; defaultColDef: { sortable: boolean; suppressNavigable: boolean; cellClass: string; suppressMovable: boolean; }; };
  context: any;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public ApiService: AuditlogServiceService
  ) { }

  ngOnInit(): void {
    this.gridBar=false;
    this.gridHeaderandActionSettings();
    this.RelatedPKID = this.Content.content.RelatedPKID;
    this.Catagory_type = this.Content.content.category_name;
    this.log_data = this.Content.content.log_data;
    this.ArrayversionId.push(this.Content.content.VersionID)
    this.ArrayCatagorytype = this.Catagory_type;
    var ArrayPost = {
      versionIDs: this.ArrayversionId,
      categories: this.ArrayCatagorytype
    }
    this.subGetAuditLogDetailsList = this.ApiService.GetAuditLogDetailsList(ArrayPost).subscribe(data => {
      this.rowData = data;
      this.RevisionNo = this.rowData.map((item) => item.RevisionNum)
    });
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,     
      
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        
      }
    }
    this.context = { componentParent: this };
  }

  ngOnDestroy(): void {
    if (this.subGetAuditLogDetailsList) this.subGetAuditLogDetailsList.unsubscribe();
    if (this.subGetAuditLogDetailsList1) this.subGetAuditLogDetailsList1.unsubscribe();
  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Revision", headerTooltip: "Revision", field: 'RevisionNum', sortable: false, resizable: true, tooltipField: 'RevisionNum' },
      { headerName: "Name", headerTooltip: "Name", field: 'Name', sortable: false, resizable: true, tooltipField: "Name" },
      { headerName: "Field Name", headerTooltip: "Field Name", field: 'FieldName', sortable: false, resizable: true, tooltipField: "FieldName" },
      { headerName: "Old Value", headerTooltip: "Old Value", field: 'OldValue', sortable: false, resizable: true, tooltipField: "OldValue" },
      { headerName: "New Value", headerTooltip: "New Value", field: 'NewValue', sortable: false, resizable: true, tooltipField: "NewValue" },
      { headerName: "Changed On", headerTooltip: "Changed On", field: 'CreatedDate', sortable: false, resizable: true, tooltipField: "CreatedDate" },
      { headerName: "Changed By", headerTooltip: "Changed By", field: 'CreatedBy', sortable: false, resizable: true, tooltipField: "CreatedBy" }
    ];
  }


  onSetGridApi(params) {
    this.gridApi = params.api;;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  OnRevisionClick() {
    var heading = "";
    let modalRef = this.modalService.open(AuditlogRevisionsComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: heading,
      content: {
        RelatedPKID: this.RelatedPKID, RevisionNo: this.RevisionNo, Category: this.Catagory_type
      }
    }
    modalRef.result.then(result => {
      //debugger
      this.versionids = [];
      this.log_data = [];
      if (result != null) {
        for (var i = 0; i < result.length; i++) {
          var id = result[i]["VersionID"].toString();
          this.versionids.push(id);
          this.revisionDetails = new RevisionDetails();
          this.revisionDetails.RevisionNum = result[i]["RevisionNum"];
          this.revisionDetails.CreatedDate = result[i]["CreatedDate"];
          this.revisionDetails.UserName = result[i]["CreatedBy"];
          this.log_data.push(this.revisionDetails);
        }
        var post = {
          versionIDs: this.versionids,
          categories: this.ArrayCatagorytype
        };

        this.subGetAuditLogDetailsList1 = this.ApiService.GetAuditLogDetailsList(post).subscribe(data => {
          this.rowData = data;
          this.RevisionNo = this.rowData.map((item) => item.RevisionNum)

        })
      }
    });
  }

  cancelmodal() {
    this.modalRef.dismiss();
  }

  RevisionNumber = (param) => {
    return param.value = this.RevisionNo
  }

  versionFormat = (params) => {
    return params.value == '0' ? 'superadmin' : params.value;
  }

  ExportToPDF() {
    let modalRef = this.modalService.open(SuperadminExportComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: {
        ID: null,
        OperationType: "View",
        log_data: this.log_data,
        details_data: this.rowData,
        cat_type: this.Catagory_type,
      }
    }
  }
}
export class RevisionDetails {
  RevisionNum: string;
  CreatedDate: string;
  UserName: string;
}
